var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"fill-current",class:_vm.classes,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"21.3 15 11 20","height":_vm.height}},[_c('path',{attrs:{"d":"M22.7 34.7l-1.4-1.4 8.3-8.3-8.3-8.3 1.4-1.4 9.7 9.7z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }